// ----------------------------------------------------------------------

export default function Button(theme) {
    return {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontSize: "16px",
                    "&:hover": {
                        boxShadow: "none",
                    },
                },
                sizeSmall: {
                    fontSize: "14px",
                },
                sizeLarge: {
                    height: 48,
                },
                containedInherit: {
                    color: theme.palette.grey[800],
                    boxShadow: "none",
                    "&:hover": {
                        backgroundColor: theme.palette.grey[400],
                    },
                },
                containedPrimary: {
                    boxShadow: "none",
                    "&:hover": {
                        backgroundColor: theme.palette.primary.main,
                    },
                },
                containedSecondary: {
                    boxShadow: "none",
                },
                outlinedInherit: {
                    border: `1px solid ${theme.palette.grey[500_32]}`,
                    boxShadow: "none",
                    "&:hover": {
                        backgroundColor: theme.palette.action.hover,
                    },
                },
                outlinedPrimary: {
                    boxShadow: "none",
                    borderColor: theme.palette.primary.main,
                    "&:hover": {
                        backgroundColor: "transparent",
                    },
                },
                outlinedInfo: {
                    boxShadow: "none",
                    "&:hover": {
                        borderColor: theme.palette.grey[500],
                        backgroundColor: "transparent",
                    },
                },
                textInherit: {
                    "&:hover": {
                        backgroundColor: theme.palette.primary.main,
                    },
                },
                textInfo: {
                    "&:hover": {
                        backgroundColor: "transparent",
                    },
                },
                textPrimary: {
                    "&:hover": {
                        backgroundColor: "transparent",
                    },
                },
            },
        },
    };
}
